import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "info-box" }
const _hoisted_3 = { class: "value" }
const _hoisted_4 = { class: "info-box" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "info-box" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "info-box" }
const _hoisted_9 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "key" }, "نام و نام خانوادگی:", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.user?.firstName ? _ctx.user.firstName : ''), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "key" }, "کد ملی:", -1)),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user?.nationalCode ? _ctx.user.nationalCode : ''), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "key" }, "تاریخ تولد:", -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.user?.birthDate ? _ctx.user.birthDate : ''), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "key" }, "وضعیت احراز هویت:", -1)),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user?.status ? _ctx.AuthStatusType(_ctx.user.status) : ''), 1)
      ])
    ])
  ]))
}